module.exports = __webpack_public_path__ + "img/mastercard-data.fec17607.svg";